module.exports = __webpack_public_path__ + "static/austin-b0e78c9c20c93fc65c7ee33b45155c4c.png";